import { typeNoteCustomerOptions } from "../assets/constants/default_options"
import { ColumnsType } from "antd/es/table"


export const breakdownColumns: ColumnsType<any> = typeNoteCustomerOptions.map(opt => ({
    key: opt.value,
    title: opt.label,
    dataIndex: 'breakdown',
    render: (breakdown: any) => breakdown?.[opt.value],
}))

export const renderResult = (result: string) => {
    const found = typeNoteCustomerOptions.find(opt => opt.value === result)
    if (found) return found.label

    if (result === 'SUCCESS') return 'Thành công'

    return result
}